//TODO inheritance for each mfe
import { createSelector } from "@ngrx/store";
import { AppState } from "@pmis3/data-access";
import { LocationState, LocationStateStatus } from "../reducers/location.reducer";

export const locationState = (state: AppState) => state.locationState;
export const selectAllLocations = createSelector(
    locationState,
    (state: LocationState) => state?.locations
);

export const selectLocationStateStatus = createSelector(
    locationState,
    (state: LocationState) => state.status
);

export const selectLocationsForBerthPlanner = createSelector(
  locationState,
  (state: LocationState) => state.locationsForBerthPlanner
)

export const selectLocationsItems = createSelector(
  locationState,
  (state: LocationState) => state.status === LocationStateStatus.SUCCESS ? state?.locations?.items : []
)

// export const selectLocationsForNOA = createSelector(
//   locationState,
//   (state: LocationState) => state.locationsForNOA
// )

// export const selectTerminalsForNOA = createSelector(
//   locationState,
//   (state: LocationState) => state.terminalsForNOA
// )